exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.faq-area-link[data-v-d2f32492] {\n  display: block !important;\n}\n", ""]);

// exports
